import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { GetClosedCohortQuery } from "generated-graphql/graphql";
import { useParams } from "react-router-dom";

export const GET_CLOSED_COHORT = gql(`
query GetClosedCohort($cohortId: ID!) {
  cohort(id: $cohortId) {
    id
    state
    chemicalCounts {
      total
      ehs
    }
    closedCohortSummary {
      state
      readyCount
      naicsCodes
      dbNumbers
      uniqueVerifiers {
        name
        email
        phone
        title
      }
      uniqueOwnerOperators {
        name
        email
        phone
        title
        address
      }
      cohortStateFieldSummary {
        key
        value
      }
      nmFacilityFeeBreakdown {
        facilityId
        facilityName
        chemicalCount
        fee
      }
      coChemicalCounts {
        facilitiesWithAtLeastOneRfcOverThreshold
        totalRfcsOverThreshold
      }
      ksFacilityBreakdown {
        ...KsFacilityBreakdownFields
      }
    }
  }
}`);

type MinimalOptions = {
  onCompleted?: (data: GetClosedCohortQuery) => void;
};

export function useClosedCohortDetails(options?: MinimalOptions) {
  const { cohortId } = useParams<{ cohortId: string }>();

  const query = useQuery(GET_CLOSED_COHORT, {
    variables: {
      cohortId: cohortId ?? "",
    },
    skip: !cohortId,
    onCompleted: options?.onCompleted,
  });

  if (query.error) throw query.error;

  return query;
}
